import { render, staticRenderFns } from "./ComparisonOfschHistory.vue?vue&type=template&id=08d43ddb&scoped=true&"
import script from "./ComparisonOfschHistory.vue?vue&type=script&lang=js&"
export * from "./ComparisonOfschHistory.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonOfschHistory.vue?vue&type=style&index=0&id=08d43ddb&prod&lang=css&"
import style1 from "./ComparisonOfschHistory.vue?vue&type=style&index=1&id=08d43ddb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d43ddb",
  null
  
)

export default component.exports